var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomVine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 907,
    height: 244,
    viewBox: "0 0 907 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_16614)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2389 103.566C79.527 124.9 100.449 110.592 100.449 110.592C100.449 110.592 113.994 89.1571 91.892 68.6902C69.7672 48.2168 21.9913 35.0032 21.9913 35.0032C21.9913 35.0032 36.9734 82.2387 58.2615 103.572L58.2389 103.566Z",
    fill: "#81C341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.574 110.186L36.8008 48.6445",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.574 110.186L36.8008 48.6445",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.616 107.452L89.4062 80.709",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6175 88.844L58.4688 83.9609",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1996 74.0827L55.5859 55.0107",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7785 59.3175L38.2617 56.5684",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2389 103.566C79.527 124.9 100.449 110.592 100.449 110.592C100.449 110.592 113.994 89.1571 91.892 68.6902C69.7672 48.2168 21.9913 35.0032 21.9913 35.0032C21.9913 35.0032 36.9734 82.2387 58.2615 103.572L58.2389 103.566Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M765.968 86.0938C772.199 75.981 764.799 69.2696 764.799 69.2696C764.799 69.2696 755.343 66.0384 749.519 76.384C743.695 86.7388 743.001 106.263 743.001 106.263C743.001 106.263 759.738 96.1973 765.969 86.0845L765.968 86.0938Z",
    fill: "#81C341"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M764.632 69.2597L746.875 99.3379",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M764.632 69.2597L746.875 99.3379",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M763.856 70.6441L754.355 76.2383",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M758.461 79.629L758.433 87.7999",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M754.212 86.8909L747.598 91.5547",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M749.96 94.1529L749.777 98.0527",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M765.968 86.0938C772.199 75.981 764.799 69.2696 764.799 69.2696C764.799 69.2696 755.343 66.0384 749.519 76.384C743.695 86.7388 743.001 106.263 743.001 106.263C743.001 106.263 759.738 96.1973 765.969 86.0845L765.968 86.0938Z",
    fill: "#81C341",
    fillOpacity: 0.25
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179 97.7294C217 115.399 271.122 129.389 280.692 115.399C321 78.2994 351.702 54.4694 367.262 48.4794C418.052 28.9294 467.082 22.9994 534.692 47.6694C555.372 55.2194 573.272 68.4594 603.602 68.5694C622.372 68.6394 625.622 64.7894 662.442 59.7094C689.792 55.9394 709.122 53.2794 734.352 54.0894C777.332 55.4694 787.342 70.7994 811.052 61.6194C817.512 59.1194 827.022 54.7194 844.302 53.2194C850.582 52.6694 867.152 55.2994 871.732 59.0194C872.842 59.9294 881.482 65.2394 879.422 71.3494C877.232 77.8494 865.532 80.9194 862.902 91.3194C862.142 94.3294 862.262 103.119 865.992 106.669C870.372 110.829 879.742 111.839 883.052 106.379C885.502 102.339 884.562 98.8694 884.772 97.7294C885.172 95.5094 887.112 100.889 885.972 106.639C885.192 110.609 879.942 114.989 874.682 115.349C862.122 116.219 852.892 107.479 851.342 95.8094C850.352 88.3194 854.012 80.5694 858.802 76.1594C861.992 73.2294 865.052 72.3494 864.792 71.2794C864.302 69.3194 854.792 68.0594 845.462 69.6694C829.182 72.4894 816.362 80.0394 812.492 81.7494C789.962 91.7294 777.272 78.8994 738.252 78.2994C724.942 78.0894 705.802 77.9994 667.672 85.6294C622.802 94.5994 621.322 96.6994 603.602 97.7294C573.132 99.4994 562.882 95.8194 524.562 88.1794C479 68.5694 448.07 53.5642 403 75.5742C370.23 91.5742 348.04 114.044 342 123.574C287 201.574 183.321 155.949 179 153.574C28 70.5742 -44.3997 177.399 -1.49844 177.399C-1.49844 195.449 -83.4683 143.129 -112.998 135.399C-169.408 120.639 -3.13844 55.7894 -1.49844 59.0194C8.29156 78.3494 76.9969 24.7294 179 97.7294Z",
    fill: "#5F9340"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179 97.7294C217 115.399 271.122 129.389 280.692 115.399C321 78.2994 351.702 54.4694 367.262 48.4794C418.052 28.9294 467.082 22.9994 534.692 47.6694C555.372 55.2194 573.272 68.4594 603.602 68.5694C622.372 68.6394 625.622 64.7894 662.442 59.7094C689.792 55.9394 709.122 53.2794 734.352 54.0894C777.332 55.4694 787.342 70.7994 811.052 61.6194C817.512 59.1194 827.022 54.7194 844.302 53.2194C850.582 52.6694 867.152 55.2994 871.732 59.0194C872.842 59.9294 881.482 65.2394 879.422 71.3494C877.232 77.8494 865.532 80.9194 862.902 91.3194C862.142 94.3294 862.262 103.119 865.992 106.669C870.372 110.829 879.742 111.839 883.052 106.379C885.502 102.339 884.562 98.8694 884.772 97.7294C885.172 95.5094 887.112 100.889 885.972 106.639C885.192 110.609 879.942 114.989 874.682 115.349C862.122 116.219 852.892 107.479 851.342 95.8094C850.352 88.3194 854.012 80.5694 858.802 76.1594C861.992 73.2294 865.052 72.3494 864.792 71.2794C864.302 69.3194 854.792 68.0594 845.462 69.6694C829.182 72.4894 816.362 80.0394 812.492 81.7494C789.962 91.7294 777.272 78.8994 738.252 78.2994C724.942 78.0894 705.802 77.9994 667.672 85.6294C622.802 94.5994 621.322 96.6994 603.602 97.7294C573.132 99.4994 562.882 95.8194 524.562 88.1794C479 68.5694 448.07 53.5642 403 75.5742C370.23 91.5742 348.04 114.044 342 123.574C287 201.574 183.321 155.949 179 153.574C28 70.5742 -44.3997 177.399 -1.49844 177.399C-1.49844 195.449 -83.4683 143.129 -112.998 135.399C-169.408 120.639 -3.13844 55.7894 -1.49844 59.0194C8.29156 78.3494 76.9969 24.7294 179 97.7294Z",
    fill: "url(#paint0_linear_4287_16614)",
    fillOpacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M240.812 168.499C223.8 147.929 204.169 158.82 204.169 158.82C204.169 158.82 190.456 176.604 208.257 196.476C226.078 216.356 267.118 231.95 267.118 231.95C267.118 231.95 257.804 189.06 240.792 168.491L240.812 168.499Z",
    fill: "#81C341"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.025 159.167L255.184 218.698",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M204.025 159.167L255.184 218.698",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.405 161.82L211.438 186.08",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221.622 179.795L238.987 185.764",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.008 194.089L239.148 211.535",
    stroke: "black",
    strokeOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M246.382 208.381L254.547 211.591",
    stroke: "black",
    strokeOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240.812 168.499C223.8 147.929 204.169 158.82 204.169 158.82C204.169 158.82 190.456 176.604 208.257 196.476C226.078 216.356 267.118 231.95 267.118 231.95C267.118 231.95 257.804 189.06 240.792 168.491L240.812 168.499Z",
    fill: "#81C341",
    fillOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4287_16614",
    x1: 488.148,
    y1: 7.45934,
    x2: 249.713,
    y2: 298.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157E0B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_16614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 972,
    height: 244,
    fill: "white",
    transform: "translate(-65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomVine);
export default __webpack_public_path__ + "static/media/bottom_vine.3ab93ca86f8a730a879f43268972a084.svg";
export { ForwardRef as ReactComponent };